<script setup lang="ts">
// TODO: Re-enable when AppSwitcher is shown again
// import AppSwitcher from './AppSwitcher.vue';
import SearchBar from './SearchBar.vue';
import HelpMenu from './HelpMenu.vue';
import UserMenu from './UserMenu.vue';
import { useSidebar } from '@/composables/useSidebar';

const { toggle: toggleSidebar } = useSidebar();
</script>

<template>
  <header class="top-header">
    <div class="header-left">
      <button
        id="sidebar-toggle"
        class="icon-btn"
        aria-label="Toggle sidebar"
        @click="toggleSidebar"
      >
        <bb-icon name="left_panel_open" decorative></bb-icon>
      </button>

      <!-- TODO: Re-enable AppSwitcher when we have more apps to show -->
      <!-- <AppSwitcher /> -->

      <RouterLink to="/" class="brand-logo">
        <img src="/images/barbri-logo.png" alt="BARBRI">
        <span class="brand-logo-text">for professionals</span>
      </RouterLink>
    </div>

    <div class="header-center">
      <SearchBar />
    </div>

    <div class="header-right">
      <HelpMenu />
      <UserMenu />
    </div>
  </header>
</template>
